export const Bio = {
  name: "Kushal Mehta",
  roles: [
    "Full Stack Developer",
    "AI/ ML Engineer",
    "Generative AI Specialist",
    "UI/UX Designer",
    "Software Engineer",
    "Freelancer",
    "Researcher",
  ],
  description:
    "I am a motivated and versatile individual, always eager to take on new challenges. With a passion for learning I am dedicated to delivering high-quality results. With a positive attitude and a growth mindset, I am ready to make a meaningful contribution and achieve great things.",
  github: "https://github.com/kushalmehta2004",
  resume:
    "https://drive.google.com/file/d/1KGcVvBQaWgpraK_A6-kJrgjEzVjuFi2e/view?usp=drive_link",
  linkedin: "https://www.linkedin.com/in/kushalmehta2004/",
  insta: "https://www.instagram.com/_kushal_mehta004/",
};

export const skills = [
  {
    title: "Frontend",
    skills: [
      {
        name: "React Js",
        image: "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9Ii0xMS41IC0xMC4yMzE3NCAyMyAyMC40NjM0OCI+CiAgPHRpdGxlPlJlYWN0IExvZ288L3RpdGxlPgogIDxjaXJjbGUgY3g9IjAiIGN5PSIwIiByPSIyLjA1IiBmaWxsPSIjNjFkYWZiIi8+CiAgPGcgc3Ryb2tlPSIjNjFkYWZiIiBzdHJva2Utd2lkdGg9IjEiIGZpbGw9Im5vbmUiPgogICAgPGVsbGlwc2Ugcng9IjExIiByeT0iNC4yIi8+CiAgICA8ZWxsaXBzZSByeD0iMTEiIHJ5PSI0LjIiIHRyYW5zZm9ybT0icm90YXRlKDYwKSIvPgogICAgPGVsbGlwc2Ugcng9IjExIiByeT0iNC4yIiB0cmFuc2Zvcm09InJvdGF0ZSgxMjApIi8+CiAgPC9nPgo8L3N2Zz4K",
      },
      {
        name: "JavaScript",
        image: "https://upload.wikimedia.org/wikipedia/commons/thumb/6/6a/JavaScript-logo.png/800px-JavaScript-logo.png",
      },
      {
        name: "Tailwind CSS",
        image: "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcSVgHWDyjwN9qZsPChFzc5PRfOOOqbfgXqR3w&s",
      },
      {
        name: "Framer Motion",
        image: "https://www.ejable.com/wp-content/uploads/2022/04/Framer-Motion.webp",
      },
      {
        name: "HTML",
        image: "https://www.w3.org/html/logo/badge/html5-badge-h-solo.png",
      },
      {
        name: "CSS",
        image: "https://upload.wikimedia.org/wikipedia/commons/thumb/d/d5/CSS3_logo_and_wordmark.svg/1452px-CSS3_logo_and_wordmark.svg.png",
      },
    ],
  },
  {
    title: "Backend & Systems",
    skills: [
      {
        name: "Python",
        image: "https://raw.githubusercontent.com/devicons/devicon/master/icons/python/python-original.svg",
      },
      {
        name: "FastAPI",
        image: "https://fastapi.tiangolo.com/img/logo-margin/logo-teal.png",
      },
      {
        name: "Node Js",
        image: "https://nodejs.org/static/images/logo.svg",
      },
      {
        name: "Socket.io",
        image: "https://upload.wikimedia.org/wikipedia/commons/9/96/Socket-io.svg",
      },
      {
        name: "MySQL",
        image: "https://raw.githubusercontent.com/devicons/devicon/master/icons/mysql/mysql-original-wordmark.svg",
      },
      {
        name: "MongoDB",
        image: "https://raw.githubusercontent.com/devicons/devicon/master/icons/mongodb/mongodb-original-wordmark.svg",
      },
    ],
  },
  {
    title: "AI Engineering & Agents",
    skills: [
      {
        name: "CrewAI",
        image: "https://registry.npmmirror.com/@lobehub/icons-static-png/1.75.0/files/dark/crewai-color.png",
      },
      {
        name: "LangGraph",
        image: "https://registry.npmmirror.com/@lobehub/icons-static-png/1.75.0/files/dark/langgraph-color.png",
      },
      {
        name: "AutoGen",
        image: "https://cdn.worldvectorlogo.com/logos/autogen-50832.svg",
      },
      {
        name: "Ollama",
        image: "https://images.seeklogo.com/logo-png/59/1/ollama-logo-png_seeklogo-593420.png",
      },
      {
        name: "Pinecone",
        image: "https://avatars.githubusercontent.com/u/74641324?s=280&v=4",
      },
      {
        name: "OpenAI",
        image: "https://freebiehive.com/wp-content/uploads/2024/02/Open-AI-Black-Logo-Icon-PNG.jpg",
      },
    ],
  },
  {
    title: "Cloud & DevOps",
    skills: [
      {
        name: "AWS",
        image: "https://upload.wikimedia.org/wikipedia/commons/9/93/Amazon_Web_Services_Logo.svg",
      },
      {
        name: "Docker",
        image: "https://www.clipartmax.com/png/middle/421-4211389_check-official-docker-logo.png",
      },
      {
        name: "GitHub Actions",
        image: "https://avatars.githubusercontent.com/u/44036562?s=280&v=4",
      },
      {
        name: "Git",
        image: "https://e7.pngegg.com/pngimages/713/558/png-clipart-computer-icons-pro-git-github-logo-text-logo-thumbnail.png",
      },
      {
        name: "Vercel",
        image: "https://assets.vercel.com/image/upload/v1588853000/repositories/vercel/logo.png",
      },
      {
        name: "Netlify",
        image: "https://www.vectorlogo.zone/logos/netlify/netlify-icon.svg",
      },
    ],
  },
  {
    title: "Computer Vision & Research",
    skills: [
      {
        name: "OpenCV",
        image: "https://upload.wikimedia.org/wikipedia/commons/3/32/OpenCV_Logo_with_text_svg_version.svg",
      },
      {
        name: "MediaPipe",
        image: "https://pnghdpro.com/wp-content/themes/pnghdpro/download/social-media-and-brands/mediapipe-logo.png",
      },
      {
        name: "LIME (XAI)",
        image: "https://raw.githubusercontent.com/marcotcr/lime/master/doc/images/lime.png",
      },
      {
        name: "ARCore",
        image: "https://cdn.iconscout.com/icon/free/png-256/free-google-arcore-logo-icon-svg-download-png-1721677.png",
      },
      {
        name: "LaTeX",
        image: "https://upload.wikimedia.org/wikipedia/commons/thumb/9/92/LaTeX_logo.svg/1200px-LaTeX_logo.svg.png",
      },
    ],
  },
  {
    title: "Design & Tools",
    skills: [
      {
        name: "Figma",
        image: "https://s3-alpha.figma.com/hub/file/1481185752/fa4cd070-6a79-4e1b-b079-8b9b76408595-cover.png",
      },
      {
        name: "VS Code",
        image: "https://upload.wikimedia.org/wikipedia/commons/thumb/9/9a/Visual_Studio_Code_1.35_icon.svg/512px-Visual_Studio_Code_1.35_icon.svg.png?20210804221519",
      },
      {
        name: "Postman",
        image: "https://yt3.googleusercontent.com/XRzDTgEa9GybH_Uk21E9ri6_iYh-9gbyZzhiEBCnLjISgjTorjMiu7IwpChUMf2lLpEdX6ufDA=s900-c-k-c0x00ffffff-no-rj",
      },
      {
        name: "Cursor",
        image: "https://miro.medium.com/v2/resize:fit:640/format:webp/0*zWCTHFNFdGAgSw2d",
      },
    ],
  },
];

export const experiences = [
  {
    id: 0,
    img: "https://d2q79iu7y748jz.cloudfront.net/s/_squarelogo/128x128/1efa9ba0bfde951c541a91f8fbd38447",
    role: "React Developer",
    company: "Puratech Solutions Pvt. Ltd.",
    date: "June 2025 - July 2025",
    desc: "Developing Soil2Soul website through React",
    skills: [
      "ReactJS",
      "PHP",
      "Laravel",
      "HTML",
      "CSS",
      "JavaScript",
      "MongoDB"
    ],
  },
  
  {
    id: 1,
    img: "https://d3v0px0pttie1i.cloudfront.net/uploads/user/avatar/26121661/80df5b08.png",
    role: "Software Developer",
    company: "Augmentables",
    date: "June 2024 - July 2024",
    desc: "Creating augmented reality based applications.",
    skills: [
      "8thWall",
      "C#",
      "HTML",
      "CSS",
      "JavaScript"
    ],
    }
  

];

export const education = [
  {
    id: 0,
    img: "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcTKi_BdHyYAiBO2quqOLGaMarndBcwm454syKxBkeJx9uVQbzPp-JsmRU96&s=10",
    school: "University of Southern California",
    date: "August 2026 - Present",
    desc: "Currently pursuing a Master of Science in Computer Science, focusing on building depth in systems and applied AI, with coursework in Analysis of Algorithms and Information Retrieval.",
    degree: "Masters of Science in Computer Science",
  },
  {
    id: 1,
    img: "https://upload.wikimedia.org/wikipedia/commons/9/9e/DJSCE_Logo.png",
    school: "Dwarkadas J. Sanghvi College Of Engineering",
    date: "Oct 2022 - May-2026",
    grade: "8.3",
    desc: "Bachelor of Technology in Information Technology, focusing on developing a strong technical foundation and specialized engineering skills.\n\nHonors: DevOps & MLOps",
    degree: "Bachelor of Technology - BTech, Information Technology",
  },
  {
    id: 2,
    img: "https://ugc.production.linktr.ee/RT0UegX6QJ6UfnlABFSI_ZgQzyeT1Rb8j7cg1?io=true&size=avatar-v3_0",
    school: "St. Wilfred's School Of Science and Commerce",
    date: "Apr 2021 - Apr 2022",
    grade: "85%",
    desc: "I completed my class 12 high school education at St. Wilfred's School of Science and Commerce, Panvel, where I studied Science with Computer Science.",
    degree: "ISC(XII)",
  },
  {
    id: 3,
    img: "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcS2_SreAFFENEuKwPa4Robw_T_fcKzb_08Agg&s",
    school: "Anchorwala Education Academy",
    date: "Apr 2019 - Apr 2020",
    grade: "85%",
    desc: "I completed my class 10 education at Anchorwala Education Academy, Navi Mumbai.",
    degree: "ICSC(X)",
  },
];

export const showcaseProjects = [
  "ATM",
  "AI-Portfolio-Agent",
  "ConversationalAI",
  "Arthur-Street-Web",
  "UpiSense",
  "ai-data-analyst-agent"
];

export const projects = [
  {
    id: 4,
    title: "ATM Management System",
    description:
      "A system designed to handle common ATM operations such as deposit, withdraw, fast cash, mini statement, change PIN, balance inquiry, and account signup. Built with .NET and SQL Server for robust transaction management.",
    image:
      "https://www.idfcfirstbank.com/content/dam/idfcfirstbank/images/blog/finance/what-is-atm-717x404.jpg",
    tags: ["Java", "AWT", "MySQL", "Gradle"],
    category: ".NET",
    github: "https://github.com/kushalmehta2004/ATM",
  },
  {
    id: 13,
    title: "AI Portfolio Agent",
    description:
      "An AI-powered personal assistant integrated into my portfolio that answers questions using RAG (Retrieval-Augmented Generation). Features a human-in-the-loop fallback system using Pushover API for real-time notifications.",
    image:
      "https://kushalmehta2004.netlify.app/ai-agent.png",
    tags: ["Hugging Face", "RAG", "Python", "React", "Pushover API"],
    category: "ai agent",
    github: "https://github.com/kushalmehta2004/AI-Portfolio-Agent",
  },
  {
    id: 14,
    title: "Conversational AI",
    description: "An advanced conversational AI project focused on natural language processing and interactive dialogue systems.",
    image: "",
    tags: ["AI", "NLP", "Python"],
    category: "ai",
    github: "https://github.com/kushalmehta2004/ConversationalAI",
  },
  {
    id: 15,
    title: "Arthur Street Kitchen + Bar",
    isFreelance: true,
    description: "A premium dining experience website featuring a modern UI, parallax hero section with video background, and interactive reservation system.",
    image: "",
    tags: ["HTML", "CSS", "JavaScript", "Parallax"],
    category: "web app",
    github: "https://github.com/kushalmehta2004/Arthur-Street-Web",
  },
  {
    id: 16,
    title: "UpiSense",
    isFreelance: true,
    description: "Your UPI money,finally explained.Forward one notification. Know exactly where your money went. No app install. No bank login. No manual entry. Ever.",
    image: "",
    tags: ["React", "Tailwind CSS", "Framer Motion", "EmailJS"],
    category: "web app",
    github: "https://github.com/kushalmehta2004/UpiSense",
  },
  {
    id: 17,
    title: "AI Data Analyst Agent",
    description: "Conversational AI data analyst that lets you upload structured datasets and ask questions in plain English.",
    image: "",
    tags: ["Python", "Streamlit", "Custom ReAct loop", "OpenAI GPT-4o", "Anthropic Claude Sonnet", "Pydantic v2", "Pandas", "NumPy", "Matplotlib", "Seaborn", "Plotly", "E2B sandbox"],
    category: "web app",
    github: "https://github.com/kushalmehta2004/ai-data-analyst-agent",
  },
];

export const research = [
  {
    id: 0,
    title: "LIME Explanation Integration for Real-Time Collision Detection using Deep Learning",
    status: "Published",
    description: "A real-time hybrid AI pipeline for estimating Time-to-Collision (TTC) in ADAS. Combines YOLOv5, DenseNet121, and Random Forest with LIME-based explainability for safety-critical deployment.",
    date: "2025",
    url: "https://drive.google.com/file/d/1PS8Xq-WxrajK1ePFotDfUFaoCNllKObV/view?usp=drive_link", 
  },
  {
    id: 1,
    title: "IndoorNavX: ARCore-Powered Markerless Indoor Navigation",
    status: "Published",
    description: "Infrastructure-free, markerless AR indoor navigation using Google ARCore and Sceneform. Employs VIO and plane detection for offline, scalable 3D directional cues in large buildings.",
    date: "2026",
    url: "https://drive.google.com/file/d/1YyUOV9gO-lt3jYqbunDmFYm0wEHiBylR/view?usp=drive_link", 
  },
  {
    id: 2,
    title: "An Adaptive Framework for Human Posture Analysis Using Layered Vision and Feedback Loops",
    description: "AI system for automated yoga posture correction using MediaPipe and Random Forest. Achieved 95.2% accuracy with synchronized audio-visual feedback for fitness and rehabilitation.",
    date: "2024",
    url: "https://drive.google.com/file/d/1B5MrRjkPXfEmbsJEXnaMbqX-KkwjRcLq/view?usp=drive_link",
  },
  {
    id: 3,
    title: "Transfer Learning and Layer-Wise Fine-Tuning for Enhancing Disease Diagnosis in Medical Images",
    description: "Comparative study of six deep learning models (ResNet50, DenseNet121, EfficientNetB4, InceptionV3, VGG19, and MobileNetV2) for multi-modal disease diagnosis across X-rays, skin images, and MRIs.",
    date: "2024",
    url: "https://drive.google.com/file/d/14rHvGTLovVXvxY3EkUigfQUIckWvy5u9/view?usp=drive_link",
  }
];
